import { i18n } from '@/i18n'

export function useBooleanFormatting() {
  const formatBooleanValue = (value: any): string => {
    return value === true ? i18n.t('yes') : i18n.t('no')
  }

  return {
    formatBooleanValue
  }
}
